<template>
  <div class="floating-layers">

    <!-- Bottom Toast Banner -->
    <transition name="el-zoom-up" v-if="!layerBanner.open">
      <div class="toastBackdrop" v-if="toastBanner.bottom" :class="{toastBackdropSearch : isCurrentRouteName('SearchCondition') || isCurrentRouteName('SearchCard') }">
        <div class="toastBanner" @click="clickToggleBanner()">
          <div>
            <display-container :section="107" bg-color="bg-grey-2">
              <template v-slot="{ component, row }">
                <img :src="component.getImage(row)">
              </template>
            </display-container>
            <!--<q-btn round dense color="black" icon="close" size="md" class="absolute-top-right" style="top: -0px; right: -0px" @click.stop="closeToastBanner()" />-->
            <div class="btnWrap">
              <a class="day" @click.stop="closeToastBannerDay()">오늘 하루 보지 않기</a>
              <a class="close" @click.stop="closeToastBanner()">닫기</a>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- Layer Banner -->
    <transition name="el-zoom-up" v-if="$route.name !== 'SpecialNHflex'">
      <div class="layerBackdrop" v-if="layerBanner.open">
        <div class="layerBanner" ref="layerBannerModal" @click="clickLayerBanner()">
          <div>
            <display-container :section="106" bg-color="bg-gray-2">
              <template v-slot="{ component, row }">
                <img :src="component.getImage(row)">
              </template>
            </display-container>
            <!--<q-btn round dense color="black" icon="close" size="md" class="absolute-top-right" @click.stop="closeLayerBanner()" />-->
            <div class="btnWrap">
              <a class="day" @click.stop="closeLayerBannerDay()">오늘 하루 보지 않기</a>
              <a class="close" @click.stop="closeLayerBanner()">닫기</a>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <b v-model="isLoadedDisplayData"></b>
  </div>
</template>

<script>
  import FloatingLayers from 'src/pc/components/FloatingLayers'
  import DisplayContainer from '../components/DisplayContainer'
  export default {
    extends: FloatingLayers,
    components: {
      DisplayContainer
    },
    created () {
      window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
    },
    computed: {
      isLoadedDisplayData () {
        const rtn = this.$store.getters.getDisplayDataCnt
        if (rtn > 10) {
          this.openLayerBanner()
          this.openToastBanner()
        }
        return rtn > 10
      },
    },
    methods: {
      openLayerBanner () {
        if (this.getExistDisplayDataBySectionIdx(106)) {
          if (!this.$cookies.isKey("closedLayerBanner") && !this.layerBanner.click) {
            setTimeout(function () {
              this.layerBanner.open = true
            }.bind(this), 20)
          }
        }
      },
      closeLayerBanner () {
        this.layerBanner.open = false
        this.layerBanner.click = true
      },
      closeLayerBannerDay () {
        this.layerBanner.open = false
        this.layerBanner.click = true
        this.$cookies.set("closedLayerBanner", true, "1d")
      },
      clickLayerBanner () {
        this.closeLayerBanner ()
      },
      openToastBanner () {
        if (this.getExistDisplayDataBySectionIdx(107)) {
          if (!this.$cookies.isKey("closedToastBanner") && !this.handleScroll) {
            setTimeout(function () {
              this.toastBanner.bottom = true
              this.$store.dispatch('setToastBannerSmallSize', false)
            }.bind(this), 20)
          }
        }
      },
      closeToastBanner () {
        this.$store.dispatch('setToastBannerSmallSize', true)
        this.toastBanner.bottom = false
        window.removeEventListener('scroll', this.handleScroll);
      },
      closeToastBannerDay () {
        this.$cookies.set("closedToastBanner", true, "1d")
        this.$store.dispatch('setToastBannerSmallSize', true)
        this.toastBanner.bottom = false
        window.removeEventListener('scroll', this.handleScroll);
      },
      clickToggleBanner () {
        this.closeToastBanner()
      },
      handleScroll (event) {
        if (this.getExistDisplayDataBySectionIdx(107)) {
          if (this.$cookies.isKey("closedToastBanner")) {
            this.toastBanner.bottom = false
          } else {
            setTimeout(function () {
              this.toastBanner.bottom = true
            }.bind(this), 500)
          }
        }
      }
    }
  }
</script>

<style scoped>
.layerBanner {
  margin: 0 auto;
  /*width: 320px;
  height: 320px;*/
  position: fixed;
  transform: translate(0, -5%);
  z-index: 7778;
  padding: 0;
}
/deep/ .layerBanner .display-container a img {
  max-width: 320px !important;
  max-height: 320px !important;
  width: 100% !important;
  height: 100% !imporatnt;
}
.layerBanner .btnWrap {
  background: #fff;
  font-size: 14px;
  font-weight: 400;
  color: #777;
  line-height: 1.0em;
}
.layerBanner .btnWrap a {
  display: inline-block;
  padding: 18px 25px;
}
.layerBanner .btnWrap .day {
  width: 70%;
}
.layerBanner .btnWrap .close {
  width: 30%;
  font-weight: 500;
  color: #000;
  text-align: right;
}
.layerBackdrop {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 7777;
  pointer-events: all;
  background: rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}
.toastBanner {
  min-width: 300px;
  min-height: 100px;
  position: fixed;
  bottom: 0;
  z-index: 6667;
}
.toastBanner .btnWrap {
  background: #fff;
  font-size: 14px;
  font-weight: 400;
  color: #777;
  line-height: 1.0em;
}
.toastBanner .btnWrap a {
  display: inline-block;
  padding: 18px 25px;
}
.toastBanner .btnWrap .day {
  width: 70%;
}
.toastBanner .btnWrap .close {
  width: 30%;
  font-weight: 500;
  color: #000;
  text-align: right;
}
/deep/ .toastBanner img {
  width: 100vw !important;
  height: auto !important;
  max-width: 640px !important;
  border-radius: 1.65em 1.65em 0 0;
}
.toastBackdrop {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 6666;
  pointer-events: all;
  background: rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}
.toastBackdropSearch {
  z-index: 167;
}
.toastBackdropSearch .toastBanner {
  bottom: 0;
}
.compare_layer .big {
  position: fixed;
  left: 50%;
  bottom: 0;
  z-index: 6668;
  transform: translate(-50%, 0);
  width: 100vw;
  height: 80px;
  text-align: center;
  background: rgba(27, 40, 56, 0.95);
}
.compare_layer .big .compare_lst {
  display: inline-block;
  padding-right: 0px;
}
.compare_layer .big .compare_lst:after {
  display: block;
  clear: both;
  content: "";
}
.compare_layer .big .compare_lst li {
  float: left;
  display: table;
  width: 60px;
  height: 80px;
  margin-right: 40px;
  background: url('/statics/img/compare_lst_bg.png') no-repeat center center;
}
.compare_layer .big .compare_lst li .card {
  display: table-cell;
  vertical-align: middle;
}
.compare_layer .big .compare_lst li .card .img {
  display: inline-block;
  position: relative;
}
.compare_layer .big .compare_lst li .card .del_btn {
  position: absolute;
  left: calc(100% - 8px);
  top: -9px;
  height: 18px;
  text-align: left;
  background: #ffa800;
  border-radius: 9px;
  cursor: pointer;
  transition: all .15s;
}
.compare_layer .big .compare_lst li .card .del_btn:hover {
  background-color: #ff3f2e;
}
.compare_layer .big .compare_lst li .card .del_btn i {
  display: inline-block;
  width: 18px;
  height: 18px;
  font-size: 0;
  text-indent: -9999px;
  background: url('/statics/img/del_x_01.png');
}
.compare_layer .big .compare_lst li .card .del_btn span {
  display: inline-block;
  height: 18px;
  line-height: 16px;
  padding: 0 0 0 0px;
  font-size: 12px;
  color: #fff;
  font-weight: 500;
}
.compare_layer .big .compare_lst li.recmd {
  width: 150px;
  margin-left: -50px;
}
.compare_layer .big .compare_lst li.recmd .card {
  width: 150px;
  height: 80px;
  margin-left: 0px;
}
.compare_layer .big .compare_lst li.recmd .card .del_btn {
  width: 50px;
}
.compare_layer .big .compare_btn {
  display: inline-block;
  width: 100px;
  height: 40px;
  line-height: 38px;
  margin-top: 20px;
  font-size: 16px;
  color: #fff;
  font-weight: 600;
  background: #ffa800;
  border-radius: 3px;
  opacity: .7;
}
.compare_layer .big .compare_btn.on {
  opacity: 1;
  cursor: pointer;
}
.compare_layer .big .compare_btn.on:hover {
  background-color: #ff3f2e;
}

</style>
